"use strict";

const all = [
  "nurse_care_manager",
  "social_worker",
  "chaplain",
  "nutritionist",
  "enrollment_review",
  "physical_therapist",
  "care_coordinator",
  "nurse_practitioner",
  "medical_director",
  "executive_director",
  "triage_enrollment_nurse",
  "administrator",
  "administrative_support",
  "broker_access",
  "csr_agent"
];

// see CM-5587
// eslint-disable-next-line no-unused-vars
const lucentShouldStartEncounterOnlyForActiveUsers = (auth, eoc) => {
  const result = true;

  try {
    // const isLucent =
    //   _.get(auth, "profile.app_metadata.partner_organization", "") === "lucent";
    // const isPatientActive = _.get(eoc, "status", "") === "active";

    return result;
  } catch (err) {
    console.log({ err }, "error in access rule");
  }
};

module.exports = {
  all: { roles: all },
  patient: {
    roles: all,
    rules: [lucentShouldStartEncounterOnlyForActiveUsers]
  },
  home: { roles: all.filter((v) => v !== "administrative_support") },
  phone: { roles: all },
  mobile: { roles: all },
  email: { roles: all },
  virtual: { roles: all.filter((v) => v !== "administrative_support") },
  administrative: { roles: all },
  grandRounds: {
    roles: [
      "nurse_practitioner",
      "medical_director",
      "executive_director",
      "administrator"
    ],
    rules: [lucentShouldStartEncounterOnlyForActiveUsers]
  },
  cms: {
    roles: all.filter(
      (v) =>
        ![
          "administrative_support",
          "triage_enrollment_nurse",
          "care_coordinator"
        ].includes(v)
    ),
    rules: [lucentShouldStartEncounterOnlyForActiveUsers]
  },
  caseManagement: { roles: all }
};
